import { render, staticRenderFns } from "./editTeam.vue?vue&type=template&id=52fcde4b"
import script from "./editTeam.vue?vue&type=script&lang=js"
export * from "./editTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports